import API_BASE_URL from './baseUrl';
import fetchWithPasskeyStepUp from './passkeyFetch';
function getCsrfToken() {
    if (typeof document === 'undefined')
        return null;
    const match = document.cookie.match(/(?:^|;\s*)_csrfToken=([^;]+)/);
    return match ? decodeURIComponent(match[1]) : null;
}
export const createApiClient = (options = {}) => {
    const baseUrl = options.baseUrl ?? API_BASE_URL;
    const defaultHeaders = options.defaultHeaders ?? { 'Content-Type': 'application/json' };
    return async (path, init) => {
        const method = String(init?.method || 'GET').toUpperCase();
        const csrfToken = method === 'GET' || method === 'HEAD' ? null : getCsrfToken();
        const response = await fetchWithPasskeyStepUp(`${baseUrl}${path}`, {
            ...init,
            headers: {
                ...defaultHeaders,
                ...(csrfToken ? { 'x-csrf-token': csrfToken } : {}),
                ...init?.headers,
            },
            credentials: 'include',
        });
        return response.json();
    };
};
export default createApiClient;
